import { render } from "./messageCardDoc.vue?vue&type=template&id=00fcd542&scoped=true"
import script from "./messageCardDoc.vue?vue&type=script&lang=js"
export * from "./messageCardDoc.vue?vue&type=script&lang=js"

import "./messageCardDoc.vue?vue&type=style&index=0&id=00fcd542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fcd542"]])

export default __exports__